import {React, useState, useEffect} from 'react'
import styles from './Weapon.module.css'
import { axiosInstance } from '../../Helpers/axiosInstance'
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'

export default function Weapon() {

    const [weaponName, setWeaponName] = useState('')
    const [weaponType, setWeaponType] = useState('')
    const [weapons, setWeapons] = useState([])
     const [change, setChange] = useState(null)
 
    useEffect(() => {
        (async() => {
            const weapons = await axiosInstance.get('admin/weapons')
            if(weapons.status){
                setWeapons(weapons.data.data)
            }
        })()
    }, [])

    const submitHandler = async () => {
        if(!weaponName){
            toast.error("Սպառազինության անվանում դաշտը պարտադիր է");
            return;
        }
        const res = await axiosInstance.post('admin/weapon', {weapon_name: weaponName, weapon_type: weaponType})
        if(res.data.status){
            setChange(null)
            setWeapons([...weapons, res.data.data])
            setWeaponName("")
            setWeaponType("")
            toast.success("Սպառազինությունը հաջողությամբ ավելացվեց");
        }
    }

    const changeHandler = async () => {
        if(!weaponName){
            toast.error("Սպառազինության անվանում դաշտը պարտադիր է");
            return;
        }
        const res = await axiosInstance.put(`admin/weapon/${change._id}`, {weapon_name: weaponName, weapon_type: weaponType})
        if(res.data.status){
            setChange(null)
            setWeapons(p => {
                let index = weapons.findIndex(el => el._id === change._id)
                const newWeapons = [...weapons]
                newWeapons[index] = {...change, weapon_name: weaponName}
                return newWeapons
            })
            setWeaponName("")
            setWeaponType("")
            toast.success("Սպառազինությունը հաջողությամբ փոփոխվեց");
        }
        
        
      }
      
      const changeWeapon = async (el) => {
        setChange(el)
        setWeaponName(el.weapon_name)
        setWeaponType(el.weapon_type)
    }
    const deleteWeapon = async (el) => {
        const res = await axiosInstance.delete(`admin/weapon/${el._id}`)
        if(res.data.status){
            setWeapons(p => {
                let index = weapons.findIndex(item => item._id === el._id)
                const newWeapons = [...weapons]
                newWeapons.splice(index, 1)
                return newWeapons
            })
            toast.success("Սպառազինությունը հաջողությամբ ջնջվեց");
        }
    }
      
      
  return (
   
<div className={styles["weapon-main-div"]}>
    <div className={styles["weapon-container"]}>
        <h2 className='mb-[20px]'>Լրացրեք սպառազինության տվյալները</h2>
        <div>
            <label htmlFor="weaponName">Սպառազինության անվանում</label>
            <input type="text" id="weaponName" value={weaponName} onChange={(e) => setWeaponName(e.target.value)}/>
        </div>
        <div>
            <label htmlFor="weaponType">Սպառազինության տեսակ</label>
            <select id="weaponType" value={weaponType} onChange={(e) => setWeaponType(e.target.value)}>
                <option value="">Հրաձգային զենքեր</option>
                <option value="XTG">ԽՏԳ</option>
                <option value="XTDH">ԽՏԴՀ</option>
                <option value="HAN17">ՀԱՆ-17</option>
                <option value="HT">ՀՏ միջոցներ</option>
                <option value="Artileria">ՀԶ և Հ</option>
                <option value="ZTT">ԱՏ և ԶՏ</option>
                <option value="AntiAir">ՀՕՊ միջոցներ</option>
                <option value="Optics">Օպտիկական  սարքեր</option>
            </select>
        </div>
        <button className={`confirm-btn`} onClick={() => change ? changeHandler() : submitHandler()}>{change ? "Փոփոխել" : "Ավելացնել"}</button>
               
    </div>



    <div className={styles["weapon-list"]}>
            <ol>
                <li className={styles["weapon-list-item"]}>
                    <p>Զենքի անուն</p> 
                </li>
                {weapons?.map((el, index) => {
                    return <li key={index} className={styles["weapon-list-item"]}>
                          
                            <p>{el?.weapon_name}</p>
                            <div className={styles["buttons"]}>
                                <button className={`btn ${styles["weapon-list-item-button"]}`} onClick={() => changeWeapon(el)}><FontAwesomeIcon icon={faPenToSquare} className={styles["edit"]} title="Խմբագրել"/></button>
                                <button className={`btn ${styles["weapon-list-item-button"]}`} onClick={() => deleteWeapon(el)}><FontAwesomeIcon icon={faTrash} className={styles["remove"]} title="Ջնջել հենակետը"/></button>
                            </div>
                        </li>
                })}
            </ol>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}
